import LoginForm from "components/Forms/custom/LoginForm";
import InfoLayout from "components/InfoLayout/InfoLayout";

const Login = () => {
  return <InfoLayout component={<LoginForm />} />;
};

export default Login;
